import { render } from "./DeliveriesCreatePage.vue?vue&type=template&id=5f10f180"
import script from "./DeliveriesCreatePage.vue?vue&type=script&lang=js"
export * from "./DeliveriesCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__